import api from "../../../lib/api";
import { put, call, takeLatest, delay } from "redux-saga/effects";

// user related apis
import {
  changeUserPasswordApi,
  createUserApi,
  editUserDetailApi,
  getLoggedInUserDataApi,
  getUserDataByIdApi,
  getUserListApi,
  loginRequestApi,
  logoutRequestApi,
} from "../requests/userRequests";

import { UserActionTypes, UserActions } from "../../actionTypes/userActionTypes";

import {
  setUserListPageCount,
  setUser,
  setUserList,
  setUserDataById,
  getUserList,
  setLoggedInUserData,
} from "../../actions/userAction";

import { startLoader, stopLoader } from "../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";
import { setPostApiStatus, setPutApiStatus } from "../../actions/apiStatusActions";


function* loginUserHandler(action: UserActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(loginRequestApi, action.payload);
    if (data.status) {
      // Set token
      yield localStorage.setItem("userAuth", "true");
      yield localStorage.setItem("accessToken", data?.data.access_token);
      yield localStorage.setItem("userId", data.data.id);
      yield (api.defaults.headers.common = {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      });

      yield put(setUser(data?.data));

      // toast message
      toast.success(`Welcome ${data?.data?.name ?? "--"}`, {
        position: "top-right",
        autoClose: 1500
      });
    } else {
      toast.error(data?.message || "Invalid login details...!", {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* logoutUserHandler(action: UserActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(logoutRequestApi);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      window.location.reload();
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });

    console.error(error)
  } finally {
    yield stopLoader("transparent");
  }
}

function* createUserHandler(action: UserActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createUserApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getUserListHandler(action: UserActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getUserListApi, action.payload);

    if (data.status) {
      yield put(setUserList(data?.data?.rows));
      yield put(setUserListPageCount(Math.ceil(data?.data?.count / action.payload.pageLimit) || 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getUserDataByIdHandler(action: UserActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getUserDataByIdApi, action.payload);
    if (data.status) {
      yield put(setUserDataById(data?.data));
    } else {
      toast.error(data.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editUserDetailByIdHandler(action: UserActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editUserDetailApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getUserList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getLoggedInUserDataHandler() {
  try {
    const { data } = yield call(getLoggedInUserDataApi);
    if (data.status) {
      yield put(setLoggedInUserData(data?.data));
      yield localStorage.setItem("office-location-id", data?.data?.user_office_location_data?.id ?? 0);
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  }
}

function* changeUserPasswordHandler(action: UserActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(changeUserPasswordApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
} 

// user sagas
export default function* userSaga() {
  yield takeLatest(UserActions.LOGIN_REQUEST, loginUserHandler);
  yield takeLatest(UserActions.LOGOUT_USER, logoutUserHandler);
  yield takeLatest(UserActions.CREATE_USER, createUserHandler);
  yield takeLatest(UserActions.GET_USER_LIST, getUserListHandler);
  yield takeLatest(UserActions.GET_USER_DATA_BY_ID, getUserDataByIdHandler);
  yield takeLatest(UserActions.EDIT_USER_DETAILS, editUserDetailByIdHandler);
  yield takeLatest(UserActions.GET_LOGGEDIN_USER_DATA, getLoggedInUserDataHandler);
  yield takeLatest(UserActions.CHANGE_USER_PASSWORD, changeUserPasswordHandler);
}
